import {
    Timeline,
    getLast12MonthsTimeline,
    getPreviousMonthTimeline,
    getPrevious2MonthsTimeline,
    getPreviousQuarterTimeline,
} from '@/utils/date'
import { TimelineFilterValue, TimelinePresetOption } from '../types'
import dayjs from 'dayjs'

export const parseTimelineFilter = (
    timelineFilterValue: TimelineFilterValue
) => {
    return timelineFilterValue.type === 'is'
        ? getTimelineValue(timelineFilterValue.value)
        : timelineFilterValue.value
}

export const getPreviousYearTimeline = (
    timelineFilterValue: TimelineFilterValue
) => {
    const currentTimeline = parseTimelineFilter(timelineFilterValue)

    return {
        startDate: dayjs(currentTimeline.startDate)
            .add(-1, 'year')
            .format('YYYY-MM-DD'),
        endDate: dayjs(currentTimeline.endDate)
            .add(-1, 'year')
            .format('YYYY-MM-DD'),
    }
}

export const getTimelineValue: (option: TimelinePresetOption) => Timeline = (
    option
) => {
    const date = new Date()

    if (option === 'last12Months') {
        return getLast12MonthsTimeline(date)
    }

    if (option === 'previousMonth') {
        return getPreviousMonthTimeline(date)
    }

    if (option === 'previous2Months') {
        return getPrevious2MonthsTimeline(date)
    }

    return getPreviousQuarterTimeline(date)
}
